<template>
    <div :class="['text-layer-content']">
        <input class="layer text-layer-input" type="text"
               :id="'text-input-' + id"
               @click="availableLayer ? $emit('addLayer') : null"
               v-model="value">
        <span class="text-layer-value">{{value}}</span>
    </div>
</template>

<script type="text/babel">

export default {
    name: 'TextLayer',
    data () {
        return {
            value: 'Text',
            active: false
        };
    },
    props: {
        availableLayer: {
            type: Boolean,
            default: false
        },
        id: {
            type: String
        },
        layer: {
            type: Object
        }
    },
    mounted () {
        let parent = document.getElementById('layer-' + this.id);
        let input = document.getElementById('text-input-' + this.id);
        parent.addEventListener('click', () => {
            input.focus();
        });
    }
};

</script>

